import React from 'react';
import mapboxgl from 'mapbox-gl';
import Beira from './stages/Beira';

export default class Map extends React.Component {
  componentDidMount() {
    mapboxgl.accessToken =
      'pk.eyJ1IjoicGxhbmV0IiwiYSI6ImNqeXJneno3ejBiN2IzbW50N3o4MXhqdHcifQ.jkd1-oyYQSgj6ORz4dlZjQ';

    // initialize map
    const map = new mapboxgl.Map({
      style: 'mapbox://styles/planet/ciz64s58j000u2rt2cyp3iuce',
      container: 'map',
      minZoom: 0,
      zoom: 1,
      center: [34.88, -19.822],
    });
    
    this.props.onMapCreated(map);

    map.on('load', function() {
      //track base layer ids
      const sourceMap = {};

      /**
       * options = {
           layout: <layer | overlay> optional, defaults to overlay
          name: <string> required
          id: <string> required
          source: <string> required
          source-layer: <string> required if source is not raster
          type: <string>, style type, defaults to 'raster'
          checked: <bool> optional, defaults to false
      * }
      */
      const addLayer = function(options) {
        const id = options.id;
        let source = options.source;
        const tiles = options.tiles;

        //Mapbox config

        //Support multiple sources linked to one control
        if (source === undefined && tiles !== undefined) {
          source = [{tiles: tiles}];
        } else if (!Array.isArray(source)) {
          source = [source];
        }
        sourceMap[id] = [];
        for (let i = 0; i < source.length; i++) {
          const sourceId = id + '-' + (i + 1);
          sourceMap[id][i] = sourceId;
          let type = options.type;
          if ((type === undefined) | (type === null)) {
            type = 'raster';
          }
          let sourceType = 'raster';
          if (type !== 'raster') {
            sourceType = 'vector';
          }
          if (source[i].tiles) {
            map.addSource(sourceId, {
              type: sourceType,
              tiles: source[i].tiles,
              tileSize: 256,
            });
          } else {
            map.addSource(sourceId, {
              type: sourceType,
              url: 'mapbox://' + source[i],
            });
          }
          const layerDef = {
            id: sourceId,
            type: type,
            source: sourceId,
            minzoom: 0,
            maxzoom: 22,
          };
          if (options['source-layer']) {
            if (Array.isArray(options['source-layer'])) {
              layerDef['source-layer'] = options['source-layer'][i];
            } else {
              layerDef['source-layer'] = options['source-layer'];
            }
          }
          map.addLayer(layerDef);

          if (!options.checked) {
            map.setLayoutProperty(sourceId, 'visibility', 'none');
          }
        }
      };

      // define map layers
      addLayer({
        name: 'PlanetScope Apr 2019',
        layout: 'layer',
        id: 'ps-mosaic-time',
        tiles: [
          'https://us-central1-planet-works.cloudfunctions.net/tile_proxy_get/tiles/global_monthly_2019_04_mosaic/gmap/{z}/{x}/{y}.png',
        ],
        checked: true
      });
      addLayer({
        name: 'SkySat Flood Extent',
        layout: 'layer',
        id: 'ss-flood',
        source: ['planet.4ee1sv2j'],
        'source-layer': [
          'Beira_HistoricalFloodExtent_S-b8l8u9',
        ],
        type: 'fill',
        checked: true
      });
      addLayer({
        name: 'Structures',
        id: 'structures',
        tiles: [
          'https://us-central1-planet-works.cloudfunctions.net/tile_proxy_get/tiles/sif-b442c53b-fc72-4bee-bab4-0b7aa318ccd9-2019-04-01/gmap/{z}/{x}/{y}.png?exp=bincat:0|ccb',
        ]
      });
      // special case for colombo, we don't have any 2019 analytics
      addLayer({
        name: 'Structures',
        id: 'structures-columbo',
        tiles: [
          'https://us-central1-planet-works.cloudfunctions.net/tile_proxy_get/tiles/sif-b442c53b-fc72-4bee-bab4-0b7aa318ccd9-2018-04-01/gmap/{z}/{x}/{y}.png?exp=bincat:0|ccb'
        ],
        bounds: [79.8142, 7.0563, 80.1785, 6.8121]
      });
      //static style
      map.setPaintProperty('structures-1', 'raster-opacity', 0.8);

      //vectortile layer with dynamic style
      addLayer({
        name: 'Flood frequency',
        id: 'flood',
        source: ['planet.6gpygeub', 'planet.5ksmbold', 'planet.dx1b7wqz'],
        'source-layer': [
          'Reclass_Beira_FloodFreq_Lands-4muvna',
          'Reclass_Colombo_FloodFreq_Lan-8532rs',
          'Reclass_Nagapattinam_FloodFre-3w95xt',
        ],
        type: 'fill',
        //checked: true,
      });
      //vectortile layer with dynamic style
      addLayer({
        name: 'Structures at risk of flood',
        id: 'structures-in-flood',
        source: ['planet.7l0ejed6', 'planet.2cx62dde', 'planet.08wb52ec'],
        'source-layer': [
          'Beira_Reclass_Urban_Extract_p-c6ge9z',
          'Reclass_Colombo_Urban_Extract-cg0pa1',
          'Reclass_Urban_Extract_Nagapat-48l56b',
        ],
        type: 'fill',
        //checked: true,
      });

      //TODO - Move to timeline
      /*
      const addLegendEntry = function(opts) {
        const legendParent = document.getElementById(opts.layerId)
          .parentElement;
        const legendContainer = document.createElement('div');
        legendContainer.className = 'pl-ctrl-legend';

        const legendMin = document.createElement('div');
        legendMin.className = 'pl-ctrl-legend-min';
        legendMin.innerHTML = opts.minText;
        const legendMax = document.createElement('div');
        legendMax.className = 'pl-ctrl-legend-max';
        legendMax.innerHTML = opts.maxText;

        const levelsDiv = document.createElement('div');
        levelsDiv.className = 'pl-ctrl-legend-levels';

        legendContainer.appendChild(legendMin);
        legendContainer.appendChild(levelsDiv);
        legendContainer.appendChild(legendMax);

        const width = 120 / opts.levels.length;

        opts.levels.forEach(function(color) {
          const level = document.createElement('div');
          level.className = 'pl-ctrl-legend-level';
          level.style =
            'background-color: ' + color + '; width: ' + width + ';';
          levelsDiv.appendChild(level);
        });
        legendParent.appendChild(legendContainer);
      };

      addLegendEntry({
        layerId: 'flood',
        minText: 'Low',
        maxText: 'High',
        levels: [
          'rgb(239, 243, 255)',
          'rgb(189, 215, 231)',
          'rgb(107, 174, 214)',
          'rgb(33, 113, 181)',
        ],
      });

      addLegendEntry({
        layerId: 'structures-in-flood',
        minText: 'Low',
        maxText: 'High',
        levels: [
          'rgb(254, 237, 222)',
          'rgb(253, 190, 133)',
          'rgb(253, 141, 60)',
          'rgb(217, 71, 1)',
        ],
      });
      */

      //TODO: Cascade effect when made visible?
      
      const updateSlider = function(event) {
        const val = parseInt(event.target.value);
        /*switch (val) {
          case 1:
            label.innerHTML = 'Low frequency';
            break;
          case 2:
            label.innerHTML = 'Medium frequency';
            break;
          case 3:
            label.innerHTML = 'High frequency';
            break;
          case 4:
            label.innerHTML = 'Very High frequency';
            break;
          default:
            label.innerHTML = 'No data';
        }*/

        const maxOpacity = '0.8';
        sourceMap['ss-flood'].forEach(function(id) {
        map.setPaintProperty(id, 'fill-color', [
            'step',
            ['get', 'DN'],
            'rgba(0, 0, 0, 0)',
            0,
            'rgba(0, 0, 0, 0)',
            1,
            'rgba(189, 215, 231, ' + maxOpacity + ')',
            2,
            'rgba(0, 0, 0, 0)',
          ]);
        });
        sourceMap['flood'].forEach(function(id) {
          map.setPaintProperty(id, 'fill-color', [
            'step',
            ['get', 'min'],
            'rgba(0, 0, 0, 0)',
            0,
            'rgba(200, 200, 200, ' + (val <= 0 ? '0.5' : '0') + ')',
            1,
            'rgba(239, 243, 255, ' + (val <= 1 ? maxOpacity : '0') + ')',
            2,
            'rgba(189, 215, 231, ' + (val <= 2 ? maxOpacity : '0') + ')',
            3,
            'rgba(107, 174, 214, ' + (val <= 3 ? maxOpacity : '0') + ')',
            4,
            'rgba(33, 113, 181, ' + (val <= 4 ? maxOpacity : '0') + ')',
          ]);
        });
        sourceMap['structures-in-flood'].forEach(function(id) {
          map.setPaintProperty(id, 'fill-color', [
            'step',
            ['get', 'min'],
            'rgba(0, 0, 0, 0)',
            0,
            'rgba(140, 140, 140, ' + (val <= 0 ? '0.5' : '0') + ')',
            1,
            'rgba(254, 237, 222, ' + (val <= 1 ? maxOpacity : '0') + ')',
            2,
            'rgba(253, 190, 133, ' + (val <= 2 ? maxOpacity : '0') + ')',
            3,
            'rgba(253, 141, 60, ' + (val <= 3 ? maxOpacity : '0') + ')',
            4,
            'rgba(217, 71, 1, ' + (val <= 4 ? maxOpacity : '0') + ')',
          ]);
        });
      };
      updateSlider({target: {value: '1'}});
      
    });

    // Mapbox GL zoom control:
    map.addControl(new mapboxgl.NavigationControl());

    //Zoom to Beira Stage 1
    map.fitBounds(new Beira().getStages()[0].aoi);
  }

  render() {
    return <div id="map"></div>;
  }
}
